import React, { useRef } from 'react';

import { isMobile } from '../../utils/media';
import { Header, Table } from './pillarTable.styles';
import { HeaderColumn, Row, RowHeader, RowContent, Cell } from './methodologyTable.styles';
import { useIntl } from 'gatsby-plugin-intl';

export const MethodologyTable = ({ chartData }, key) => {
  const tableRef = useRef(null);
  const { fields = [], records } = chartData;

  const columnsNames = [];
  const intl = useIntl();

  const columnsIds = Object.values(fields).map(({ name }) => {
    columnsNames.push(name.toUpperCase());

    const [first, ...rest] = name.split(' ');
    const restName = rest.map((item) => `${item[0].toUpperCase()}${item.slice(1)}`).join('');

    return `${first[0].toLowerCase()}${first.slice(1)}${restName}`;
  });

  const table = Object.values(records).map((row) => {
    const [headerId, ...restIds] = columnsIds;

    return {
      content: row[headerId],
      children: restIds.map((id) => row[id]),
    };
  });

  const renderHeaders = (name, key) => (
    <HeaderColumn key={key} column={name}>
      {intl.formatMessage({ id: name })}
    </HeaderColumn>
  );

  const renderCells = (content, key) => (
    <Cell key={key} column={columnsNames[key + 1]}>
      {intl.formatMessage({ id: content })}
    </Cell>
  );

  const handleHeaderClick = (key) => () => {
    if (!isMobile()) return;

    const item = tableRef.current.querySelectorAll(RowContent)[key];
    const height = parseInt(item.style.height, 10);

    if (height) {
      item.style.height = '0px';
    } else {
      item.style.height = `${item.scrollHeight}px`;
    }
  };

  const renderRow = ({ content, children }, key) => {
    const useColor = (key + 1) % 2;

    return (
      <Row key={key} useColor={useColor}>
        <RowHeader onClick={handleHeaderClick(key)}>{intl.formatMessage({ id: content })}</RowHeader>
        <RowContent>{children.map(renderCells)}</RowContent>
      </Row>
    );
  };

  return (
    <div key={key}>
      <Header>{columnsNames.map(renderHeaders)}</Header>
      <Table ref={tableRef}>{table.map(renderRow)}</Table>
    </div>
  );
};
